import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';
import { PhArrowRight } from 'ember-phosphor-icons';
import type { BetaAlert } from 'tio-employee/utils/beta/home-model';

/**
 * One row of the "Needs Your Attention" panel.
 *
 * Design: 48px tinted icon tile, title + tone badge, description, and a
 * right-aligned link with a trailing arrow. Tone comes from the smart action's
 * priority (urgent → danger/"Act Now", high → warning/"Due Soon").
 */
const BetaHomeAlertRow: TOC<{
  Args: { alert: BetaAlert };
  Element: HTMLDivElement;
}> = <template>
  <div class="tio-beta-home__alert" data-test-beta-alert={{@alert.id}} ...attributes>
    <div class="tio-beta-home__alert-body">
      <div class="tio-beta-home__alert-icon tio-beta-home__alert-icon--{{@alert.tone}}">
        {{#let @alert.icon as |Icon|}}
          <Icon @size={{24}} />
        {{/let}}
      </div>

      <div class="tio-col-extra-tight">
        <div class="tio-row-tight">
          <span class="tio-beta-home__alert-title">{{@alert.title}}</span>
          <span
            class="tio-beta-home__badge tio-beta-home__badge--{{@alert.tone}}"
          >{{@alert.badge}}</span>
        </div>
        <p class="tio-beta-home__alert-copy">{{@alert.description}}</p>
      </div>
    </div>

    {{#if @alert.models}}
      <LinkTo @route={{@alert.route}} @models={{@alert.models}} class="tio-beta-home__link">
        <span>{{@alert.cta}}</span>
        <PhArrowRight @size={{20}} />
      </LinkTo>
    {{else}}
      <LinkTo @route={{@alert.route}} class="tio-beta-home__link">
        <span>{{@alert.cta}}</span>
        <PhArrowRight @size={{20}} />
      </LinkTo>
    {{/if}}
  </div>
</template>;

export default BetaHomeAlertRow;
